document.addEventListener('DOMContentLoaded', () => {

    const slider =
        document.querySelector('.specialties__top');

    const prev =
        document.querySelector('.specialties__nav--prev');

    const next =
        document.querySelector('.specialties__nav--next');

    if (!slider || !prev || !next) return;

    function getScrollAmount() {

        const card =
            slider.querySelector(
                '.specialties__top-card'
            );

        if (!card) return 300;

        const gap = 20;

        return card.offsetWidth + gap;
    }

    prev.addEventListener(
        'click',
        () => {

            slider.scrollBy({

                left:
                    -getScrollAmount(),

                behavior:
                    'smooth'
            });
        }
    );

    next.addEventListener(
        'click',
        () => {

            slider.scrollBy({

                left:
                    getScrollAmount(),

                behavior:
                    'smooth'
            });
        }
    );

});